import { GatsbyImage } from 'gatsby-plugin-image';
import kebabCase from 'lodash.kebabcase';
import PropTypes from 'prop-types';
import React from 'react';

import { ALT_TEXT_PREFIX } from '../../../constants/global';

const Image = ({ alt, gatsbyImageData }) => {
    // Format string to match <img /> alt best practices
    const altify = (string) => ALT_TEXT_PREFIX + kebabCase(string);

    return <GatsbyImage alt={altify(alt)} image={gatsbyImageData} />;
};

Image.propTypes = {
    alt: PropTypes.string.isRequired,
    gatsbyImageData: PropTypes.object.isRequired,
};

export default Image;
